import React from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastr';
import RegisterForm from './Form';
import SIGNUP_MUTATION from '../../../graphql/SignUp';

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  handleArtistCreation = (usr) => {
    const { mutate, history } = this.props;

    this.setState({ saving: true }, () => {
      mutate({
        variables: usr,
      })
        .then(() => {
          this.toastr.success('Tu perfil fue creado exitosamente, confirmaremos tu cuenta a través de un correo electrónico');

          setTimeout(() => {
            history.push({
              pathname: '/',
              state: { msg: 'Tu perfil fue creado exitosamente, confirmaremos tu cuenta a través de un correo electrónico' },
            });
          }, 2000);
        })
        .catch(() => {
          this.toastr.error('Correo electrónico ya registrado o falla de conexión');
          this.setState({
            error: 'Correo electrónico ya registrado o falla de conexión',
          });
        })
        .finally(() => this.setState({ saving: false }));
    });
  };

  render() {
    return (
      <div className="login__page">
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-left-i form-content-box" style={{ maxWidth: '100%' }}>
                <div className="details">
                  <Link to="/">
                    <img
                      src="/img/logos/logo-2.png"
                      className="cm-logo"
                      alt="black-logo"
                    />
                  </Link>
                  <h3>Registro</h3>
                  <RegisterForm
                    error={this.state.error}
                    saving={this.state.saving}
                    onCreateArtist={this.handleArtistCreation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const withMutation = graphql(SIGNUP_MUTATION);

export default withMutation(RegisterPage);



// WEBPACK FOOTER //
// ./src/containers/General/RegisterPage/index.js